// Dependencies
import React from 'react';
import { render } from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './Components/App';
import history from './history';
// Routes
import AppRoutes from './routes';

// Assets
import './index.css';

import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

render(
  <Router history={history}>
    <App />
  </Router>,
  document.getElementById('root')
);

serviceWorkerRegistration.register({
  onUpdate: async (registration) => {
    if (registration && registration.waiting) {
      await registration.unregister();
      registration.waiting.postMessage({ type: "SKIP_WAITING" });
      window.location.reload();
    }
  },
});


// WEBPACK FOOTER //
// ./src/index.js